module.exports = __webpack_public_path__ + "media/images/avatar_default-9d595df8a640c8de8cc59e32b2e33f39.jpg";